import { serializeType } from "@app/shared";
import { Type } from 'class-transformer';

export class FeedbackPost {
  id: number;
  post: string;
  feedbackSubjectId: number;
  subject: string;
  userFullName: string;
  @Type(serializeType(Date)) createdOn: Date;
}


export class FeedbackSubject {
  id: number;
  version: number;
  subject: string;
  feedbackCategory: string;
}

export class Subject {
  id: number;
  name: string;
}